// removed by extract-text-webpack-plugin
module.exports = {"base":"UpgradeTooltip_base--FBgXb","body":"UpgradeTooltip_body--1Ue88","wrapper":"UpgradeTooltip_wrapper--1afgZ","background":"UpgradeTooltip_background--tHVrC","content":"UpgradeTooltip_content--1Fds9","title":"UpgradeTooltip_title--2S_qU","message":"UpgradeTooltip_message--8EUSs","divider":"UpgradeTooltip_divider--zA3iP","highlight":"UpgradeTooltip_highlight--ujkkl","ribbon":"UpgradeTooltip_ribbon--1qCj6"};


//////////////////
// WEBPACK FOOTER
// ./containers/BuildingCard/components/UpgradeTooltip/UpgradeTooltip.scss
// module id = 2117
// module chunks = 11